import { useRef, useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { useSelector, useDispatch } from "react-redux";
import { Alert } from '@mui/material';

//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    Button,
    Input
} from "@gpstrackit/react-controls";

//Actions
import {
    loginForgotPasswordRequest,
    loginConfirmForgotPasswordRequest,
    clearRedux
} from "Redux/actions";

//helpers
import {
    ErrorHandlerLogin
} from 'Core/data/Helpers';

//Notification
import {
    NotificationManager
} from "Components/Notifications";

//Helpers
import { passwordValidation } from 'Utils/helpers';

//Styles
import "./forgotPassword.scss";

const ForgotPassword = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formUserRef = useRef();
    const formCodeRef = useRef();

    //Local states
    const [username, setUsername] = useState("");
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [errorUsername, setErrorUsername] = useState(false);
    const [confirmationCode, setConfirmationCode] = useState("");
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");

    //Redux State
    const {
        openModal,
        resultForgotPassword,
        errorForgotPassword,
        errorConfirmForgotPassword,
        resultConfirmForgotPassword
    } = useSelector(state => state.loginRedux);


    const closeModal = () => {
        setUsername("");
        setConfirmPassword(false);
        setErrorUsername(false);
        setConfirmationCode("");
        setPassword("");
        setRepeatPassword("");
        dispatch(clearRedux("LOGIN"))
    }

    useEffect(() => {
        if (errorForgotPassword) {
            setConfirmPassword(false);
            NotificationManager.error(messages[errorForgotPassword], messages['forgot_password_password_recovery'], 3000, null, null, '', null);
            dispatch(clearRedux("LOGIN", { errorForgotPassword: null }))
        }
        if (resultForgotPassword) {
            dispatch(clearRedux("LOGIN", { resultForgotPassword: null }))
            setConfirmPassword(true);

            NotificationManager.success(messages['forgot_password_message_success'], messages['forgot_password_password_recovery'], 5000, null, null, '', null);
            closeModal();
        }
        
    }, [resultForgotPassword, errorForgotPassword, errorConfirmForgotPassword, resultConfirmForgotPassword]);

    return (
        <Modal
            open={openModal}
            title={messages['forgot_password_password_recovery']}
            size="small"
            handleClose={() => closeModal()}
        >
            <ModalBody>
                {
                    <Form
                        ref={formUserRef}
                        onValidSubmit={() => {
                            dispatch(loginForgotPasswordRequest({ username: username?.trim() }));
                        }}
                    >
                        <div className="forgot-password-container">
                            <Input
                                label={messages['forgot_password_username']}
                                required
                                placeholder={messages['forgot_password_username_placeholder']}
                                requiredMessage={messages['required_field']}
                                value={username}
                                className={errorUsername ? "form-control-invalid" : ""}
                                onChange={(value) => {
                                    setErrorUsername(false);
                                    setUsername(value)
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <span>
                                {messages['forgot_password_message']}
                            </span>
                        </div>
                    </Form>

                }
            </ModalBody>
            <ModalFooter>
                <div className="forgot-password-footer">
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            closeModal();
                        }}
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            setErrorUsername(false);
                            formUserRef.current?.submit();
                        }}
                    >
                        {messages['send']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default ForgotPassword;